import { Providers } from "@/components/Providers";
import { RoquaLayout } from "@/components/organisms/RoquaLayout";
import { environment } from "@/lib/environment";
import { getEndpoint } from "@/lib/getEndpoint";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/$organizationKey/$dossierId/$researchProjectId")({
  component: ResearchProjectLayout,
});

function ResearchProjectLayout() {
  const { organizationKey, dossierId, researchProjectId } = Route.useParams();
  const apiEndpoint = getEndpoint(environment);

  return (
    <Providers
      apiEndpoint={apiEndpoint}
      organizationKey={organizationKey}
      dossierId={dossierId}
      researchProjectId={researchProjectId}
    >
      <RoquaLayout>
        <Outlet />
      </RoquaLayout>
    </Providers>
  );
}
